import styled from 'styled-components';

export const City = styled.div`
  font-size: 14px;
  line-height: 1.5em;
  color: var(--grey100);

  @media (orientation: landscape) and (max-width: 1030px) {
    html.zoom-lg & {
      display: none;
    }
  }
`;

export const Location = styled.div.attrs(() => ({
  className: 'location',
}))`
  position: relative;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-family: var(--primary-font), sans-serif;
  font-weight: 600;
  color: var(--grey100);

  &.location_header {
    position: relative;
    margin-left: 1vw;
    text-decoration: none;
    display: flex;
    align-items: center;
    font-family: var(--primary-font), sans-serif;
    font-weight: 600;
    color: var(--grey100);

    .icon {
      fill: var(--grey50);
      margin-right: 8px;
      flex-shrink: 0;
    }

    @media (max-width: 767px) {
      display: none;
    }

    @media (orientation: landscape) and (max-width: 1030px) {
      html.zoom-lg & .icon {
        margin-right: 0;
      }
    }
  }

  .icon {
    fill: var(--grey50);
    margin-right: 8px;
    flex-shrink: 0;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

export const LocationCont = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    ${City} {
      color: var(--theme-palette-brand-color);
    }

    .icon {
      fill: var(--theme-palette-brand-color);
    }
  }
`;
